import { HStack, Text, VStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import { LateralBar } from '../../../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import {
  DetailsSkeleton,
  TextSkeleton,
} from '../../../../../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';
import { useGlobalProductContext } from '../../../../../contexts';

export const ListLoadingItemMobile: React.FC = () => {
  const { product } = useGlobalProductContext();

  const middleInfos1 = [
    { label: 'Tipo', value: <TextSkeleton w="60%" />, w: '49%' },
    { label: 'Mês', value: <TextSkeleton w="60%" />, w: '49%' },
  ];

  const middleInfos2 = [
    { label: 'Ano', value: <TextSkeleton w="60%" />, w: '49%' },
    { label: '12 Meses', value: <TextSkeleton w="60%" />, w: '49%' },
  ];

  const middleInfos3 = [
    { label: 'Aplic. Min', value: <TextSkeleton w="60%" />, w: '49%' },
    { label: 'Data início', value: <TextSkeleton w="60%" />, w: '49%' },
  ];

  const middleInfos4 = [{ label: 'Data de referência', value: <TextSkeleton w="60%" />, w: '49%' }];

  const infos = [middleInfos1, middleInfos2, middleInfos3, middleInfos4];

  return (
    <TableContent direction="row" space={0} p={0} px={Spacing['inline.xxxs']}>
      <LateralBar
        backgroundColor={product.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <VStack padding={Spacing['inset.sm']} space={Spacing['stack.xxxs']} w="full">
        <HStack alignItems="center" space={Spacing['inline.quarck']}>
          <DetailsSkeleton />
          <TextSkeleton w="35%" />
        </HStack>
        {infos.map((info, i) => (
          <HStack justifyContent="space-between" key={`infos-${i}`}>
            {info.map(({ label, value, w }) => (
              <VStack width={w} space={Spacing['stack.quarck']} key={label}>
                {!!label && (
                  <Text color="neutral.black" variant="semibold">
                    {label}
                  </Text>
                )}
                {value}
              </VStack>
            ))}
          </HStack>
        ))}
      </VStack>
    </TableContent>
  );
};
